export const api3 = 'https://adminbm.sdsstaging.co.uk'
export const api2 = 'https://admin.onlinebeauty.sdsstaging.co.uk'
export const api = 'https://admin.beauty-meetings.com'
export const Vat_check_api = "https://api.vatcomply.com/vat?vat_number"
export const vat_rate_api = "http://apilayer.net/api/price?access_key=6a3f5f2221b2c46706924203fe1bda51&amount"
export const stripe_charge = "https://www.beauty-meetings.com:3001/stripe/charge"
export const stripe_tax_rate = "https://api.stripe.com/v1/tax_rates"
export const stripe_costumer = "https://api.stripe.com/v1/subscriptions"
export const stripe_recurring_subscription = "https://www.beauty-meetings.com:3001/stripe/subscription";
export const stripe_cancel_sub = "https://www.beauty-meetings.com:3001/cancel-subscription"